import { Box, Skeleton } from '@mui/material';

const ScheduleSkeleton = () => (
  <Box
    sx={{
      border: '1px solid #ddd',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
      display: 'flex',
      bgcolor: '#fff',
      mt: 2,
      mb: '48px',
    }}
  >
    <Box sx={{ width: 48, borderRight: '1px solid #e0e0e0', bgcolor: '#fafafa' }} />
    {Array.from({ length: 6 }).map((_, i) => (
      <Box
        key={i}
        sx={{
          minWidth: 260,
          flex: '0 0 260px',
          borderRight: '1px solid #e0e0e0',
          '&:last-child': { borderRight: 'none' },
        }}
      >
        <Skeleton variant="rectangular" height={38} sx={{ bgcolor: '#2a2a2a' }} />
        {Array.from({ length: 16 }).map((_, j) => (
          <Box key={j} sx={{ px: 1.5, height: 40, borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center' }}>
            {j % 4 === 0 && (
              <Skeleton variant="rounded" height={28} width={`${55 + (j % 3) * 15}%`} sx={{ borderRadius: '6px' }} />
            )}
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);

export default ScheduleSkeleton;